import { Badge } from '@systemeio/components'
import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface PillRadioOption<T extends string> {
  id: T
  caption: ReactNode
  icon?: ReactNode
}

interface PillRadioGroupProps<T extends string> {
  className?: string
  disabled?: boolean
  onChange: (value: T) => void
  options: PillRadioOption<T>[]
  value?: T
}

export function PillRadioGroup<T extends string>({
  className,
  disabled,
  onChange,
  options,
  value,
}: PillRadioGroupProps<T>) {
  return (
    <div className={twMerge('flex flex-wrap gap-2', className)} role="radiogroup">
      {options.map(option => {
        const isActive = option.id === value

        return (
          <Badge
            className={twMerge(
              'focus-visible:focus-ring-primary transition-base cursor-pointer outline-none',
              'disabled:cursor-not-allowed',
              isActive && 'border-border-accent',
            )}
            color="outlinedGray"
            key={option.id}
            render={
              <button
                aria-checked={isActive}
                disabled={disabled}
                onClick={() => onChange(option.id)}
                role="radio"
                type="button"
              />
            }
            size="xl"
          >
            {option.icon}
            {option.caption}
          </Badge>
        )
      })}
    </div>
  )
}
